module.exports = __webpack_public_path__ + "79e3f66c145322a62d9be0498f63a639.png";